var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ext"},[_c('div',{ref:"chartDom",staticClass:"echarts-dom",style:(_vm.chartWrapStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }